import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Table, Input } from 'antd';
import { toJS, runInAction, action } from 'mobx';
import { columns, recommendColumns } from "./data"

const TextArea = Input.TextArea;

@inject('store')
@observer
class App extends Component {

    @action
    onChange = (name, value, i) => {
        let data = toJS(this.props.store.salesPersonnel.recommend);
        data[i][name] = value;
        this.props.store.salesPersonnel.recommend = data;
    }
    render() {
        const { recommend, loading } = this.props.store.salesPersonnel;

        return (
            <div className="">
                <Row className="secondary_title">销售部员工推荐</Row>
                <Table
                    columns={recommendColumns({ name: "销售部员工推荐", onChange: this.onChange })}
                    dataSource={loading ? [] : recommend}
                    size="middle"
                    bordered
                    pagination={false}
                    className="content"
                    rowKey={(record, index) => index}
                />
            </div >
        );
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/salesPersonnelAssessment/Recommend.js